import React from "react"
import autobind from "class-autobind"
import ShiftTemplatesChip from "./ShiftTemplatesChip"
import { TextField } from "material-ui"
import { IScheduleShift, ISchedulePatternTemplate, IClientDocument, IJobDocument } from "../../../models"
import strings from "../../../localization/strings"
import * as utils from "../../../helpers/utils"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
interface IProps {
  hierarchyId: string
  handleSave(patternTemplate: ISchedulePatternTemplate): void
  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}
interface IState {
  id: string
  name: string
  errorName: string
  description: string
  shiftTemplates: IScheduleShift[]
  errorShiftTemplates: string
}

export default class CreateMultiplePositionShift extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      id: utils.guid(),
      name: "",
      errorName: strings.NameRequired,
      description: "",
      shiftTemplates: [],
      errorShiftTemplates: strings.This_field_is_required,
    }
    autobind(this)
  }

  checkValidateForNewShift() {
    let isValidate = true
    if (!this.state.name.trim()) {
      this.setState({ errorName: strings.NameRequired })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }
    if (this.state.shiftTemplates.length === 0) {
      this.setState({ errorShiftTemplates: strings.This_field_is_required })
      isValidate = false
    }
    else if (this.state.shiftTemplates.length === 1) {
      this.setState({ errorShiftTemplates: "" })
    }
    else {
      const isNotOverlapped = scheduleHelper.checkOverlapShifts1(this.state.shiftTemplates)
      if (!isNotOverlapped) {
        this.setState({ errorShiftTemplates: strings.Shift_times_are_overlapped })
        isValidate = false
      }
    }
    return isValidate
  }

  handleSave() {
    const payload: ISchedulePatternTemplate =
      this.checkValidateForNewShift() ?
        {
          Id: utils.guid(),
          Name: this.state.name.trim(),
          Description: this.state.description,
          HierarchyId: this.props.hierarchyId,
          ShiftTemplates: this.state.shiftTemplates
        } :
        null
    this.props.handleSave(payload)
  }

  render() {
    return (
      <div>
        <div style={{ width: "100%" }}>
          <TextField
            data-intercom-target={"Shift-AddShift-Entry-Name"}
            floatingLabelText={strings.Name}
            value={this.state.name}
            onChange={(e, value) => this.setState({ name: value }, () => this.handleSave())}
            errorText={this.state.errorName}
            errorStyle={{ position: "absolute", bottom: -10 }}
            fullWidth={true}
          />
        </div>
        <div style={{ width: "100%" }}>
          <TextField
            data-intercom-target={"Shift-AddShift-Entry-Description"}
            floatingLabelText={strings.Description}
            value={this.state.description}
            onChange={(e, value) => this.setState({ description: value }, () => this.handleSave())}
            fullWidth={true}
          />
        </div>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          <ShiftTemplatesChip
            errorText={this.state.errorShiftTemplates}
            shiftTemplates={this.state.shiftTemplates}
            shiftTemplateHierarchyId={this.props.hierarchyId}
            handleChange={(shiftTemplates) => this.setState({ shiftTemplates }, () => this.handleSave())}
            scheduleJob={this.props.scheduleJob}
            scheduleClient={this.props.scheduleClient}
          />
        </div>
      </div>
    )
  }
}
